<template>
  <div id="app" :dir="languageMode" v-if="isBrandselect() || languageReady">
    <div class="position-absolute mainLoader" v-if="spinnerVisible">
      <md-progress-spinner
        :md-diameter="100"
        :md-stroke="10"
        md-mode="indeterminate"
      ></md-progress-spinner>
    </div>
    <!-- v-if="spinnerVisible" -->
    <router-view />
    <!-- 모바일/PC/타블렛 화면 분기 시 사용할 수 있는 코드 주석 -->
    <!-- Code comments available for mobile/PC/Tablet screen branching -->
    <!-- <router-view v-if="isMobile()"/>
        <router-view v-else name="pcRouter"/> -->
  </div>
  <div v-else class="position-absolute mainLoader">
    <md-progress-spinner
      :md-diameter="30"
      :md-stroke="3"
      md-mode="indeterminate"
    ></md-progress-spinner>
  </div>
</template>
<script>
// Store 임포트
import { mapState } from "vuex";
import { eventHub } from "./eventhub";
export default {
  name: "Main",
  data() {
    return {
      spinnerVisible: false,
      languageReady: false,
    };
  },
  computed: {
    ...mapState(["languageMode"]),
  },
  watch: {
    "$i18n.locale"(newLocale) {
      const messagesReady = this.$i18n.getLocaleMessage(newLocale);
      this.languageReady = !!(
        newLocale &&
        messagesReady &&
        Object.keys(messagesReady).length > 0
      );
    },
  },

  methods: {
    hideSpinner() {
      this.spinnerVisible = false;
    },
    // Mobile Check
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },

    isBrandselect() {
      return this.$route.path.includes("brandselect");
    },
  },
  beforeDestroy() {
    eventHub.$off("before-request", this.showSpinner);
    eventHub.$off("request-error", this.hideSpinner);
    eventHub.$off("after-response", this.hideSpinner);
    eventHub.$off("response-error", this.hideSpinner);
  },
};
</script>
<style lang="scss">
.mainLoader {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
  background: rgba(255, 255, 255, 1);
}
</style>
